import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#7EC1FB"
      fillRule="evenodd"
      d="M10.001 18.96a8.958 8.958 0 1 1 0-17.917 8.958 8.958 0 0 1 0 17.917Zm3.734-11.144a.833.833 0 0 0-.8-1.462c-1.524.833-2.784 2.441-3.631 3.739-.313.48-.58.933-.795 1.318a8.239 8.239 0 0 0-1.166-.928l-.262-.164a.833.833 0 0 0-.826 1.448l.175.11c.12.077.286.193.471.34.382.3.793.696 1.052 1.129a.833.833 0 0 0 1.473-.081l.082-.172a20.51 20.51 0 0 1 1.191-2.09c.82-1.254 1.893-2.562 3.036-3.187Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
